var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12 form-group" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: "category_divisionId" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_DivisionId_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _vm.divisions
              ? _c("division-dropdown", {
                  key: _vm.category.divisionId,
                  attrs: {
                    id: "category_divisionId",
                    divisionList: _vm.divisions
                  },
                  model: {
                    value: _vm.category.divisionId,
                    callback: function($$v) {
                      _vm.$set(_vm.category, "divisionId", $$v)
                    },
                    expression: "category.divisionId"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            { staticClass: "control-label", attrs: { for: "category_name" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_Name_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.category.name,
                  expression: "category.name"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "category_name", type: "text" },
              domProps: { value: _vm.category.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.category, "name", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.nameIsMissing
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_Name_DisplayName"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            { staticClass: "control-label", attrs: { for: "category_label" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_Label_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-8 mb-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.category.label,
                expression: "category.label"
              }
            ],
            staticClass: "form-control",
            attrs: { id: "category_label", type: "text" },
            domProps: { value: _vm.category.label },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.category, "label", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: "category_sortOrder" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_SortOrder_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.category.sortOrder,
                  expression: "category.sortOrder",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: { id: "category_sortOrder", type: "number" },
              domProps: { value: _vm.category.sortOrder },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.category,
                    "sortOrder",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.sortOrderIsMissing
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_SortOrder_DisplayName"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 mb-2" }, [
          _c(
            "label",
            {
              staticClass: "control-label",
              attrs: { for: "category_colSpan" }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_ColSpan_DisplayName"
                    )
                  ) +
                  "\n                "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 mb-2" },
          [
            _c("dropdown", {
              attrs: { id: "category_colSpan", options: _vm.colSpanOptions },
              model: {
                value: _vm.category.colSpan,
                callback: function($$v) {
                  _vm.$set(_vm.category, "colSpan", _vm._n($$v))
                },
                expression: "category.colSpan"
              }
            }),
            _vm._v(" "),
            _vm.colSpanIsMissing
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "DivisionMiscellaneousCategoryEditModel_ColSpan_DisplayName"
                    )
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _vm.canAddFields
      ? _c("div", { staticClass: "col-12 text-right" }, [
          _c(
            "button",
            { staticClass: "btn btn-primary", on: { click: _vm.addField } },
            [
              _vm._v(
                _vm._s(
                  _vm.resource(
                    "SettingsDivisionMiscellaneous_Index_AddFieldButton_Text"
                  )
                )
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      _vm._l(_vm.category.fields, function(field) {
        return _c(
          "div",
          { key: field.id },
          [
            _c("div", { staticClass: "row mb-2" }, [
              _c("div", { staticClass: "col-6" }, [
                _c("h4", [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "SettingsDivisionMiscellaneous_Index_FieldsHeader"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.deletableFieldIds.indexOf(field.id) !== -1
                ? _c("div", { staticClass: "col-6 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        on: {
                          click: function($event) {
                            return _vm.deleteField(field)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.resource(
                                "SettingsDivisionMiscellaneous_Index_DeleteFieldButton_Text"
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("miscellaneous-field", {
              staticClass: "form-group",
              attrs: { field: field }
            })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  }
]
render._withStripped = true

export { render, staticRenderFns }